import { questions } from '../../components/DifferentRetainer/Question';
import { IMPRESSION_TYPE } from '../../pages/hooks/DiffRetainerHooks/useRetainerRequestForm';
import {
    SET_SUPPROTED_RETAINTER_TYPES,
    SAVE_FORM_VALUES,
    RESET_FORM_VALUES,
    SET_TOOTH_SELECTIONS,
    RESET_TOOTH_SELECTIONS,
    SET_QUESTIONS,
    SET_ENABLE_ORDER_DIFFERENT_RETAINER,
    SET_TARGET_TYPE_FORM_VALIDATION_FUNC,
    SAVE_IMPRESSION_TYPE_FORM_VALUES,
    SET_SINGLE_TYPE_BITE_RAMP_TEETH_SELECTIONS,
    SET_SPECIAL_INSTRUCTION,
    SET_RETAINER_REQ_ID,
    SET_BOTH_UPPER_TYPE_BITE_RAMP_TEETH_SELECTIONS,
    SET_BOTH_LOWER_TYPE_BITE_RAMP_TEETH_SELECTIONS,
    RESET_SINGLE_TOOTH_SELECTIONS,
} from './actionType';

const initFormvalue = {
    impressionType: null,
    upperFixedWire: null,
    upperArchAndQuantity: null,
    upperBleachingRetainersSelect: null,
    upperWireSelect: null,
    upperOcclusalBiteRampQuestion: null,
    upperClearRetainerDesignUpper: null,
    upperClearRetainerDesignUpperOption: null,
    // "upperClearRetainerDesignLower": null,
    // "upperClearRetainerDesignLowerOption": null,
    upperClearRetainerDesignUpperForSecondSet: null,
    upperClearRetainerDesignUpperOptionForSecondSet: null,
    // "upperClearRetainerDesignLowerForSecondSet": null,
    // "upperClearRetainerDesignLowerOptionForSecondSet": null,
    upperPontics: null,
    upperBiteRamp: null,
    lowerFixedWire: null,
    lowerArchAndQuantity: null,
    lowerBleachingRetainersSelect: null,
    lowerWireSelect: null,
    lowerOcclusalBiteRampQuestion: null,
    // "lowerClearRetainerDesignUpper": null,
    // "lowerClearRetainerDesignUpperOption": null,
    lowerClearRetainerDesignLower: null,
    lowerClearRetainerDesignLowerOption: null,
    // "lowerClearRetainerDesignUpperForSecondSet": null,
    // "lowerClearRetainerDesignUpperOptionForSecondSet": null,
    lowerClearRetainerDesignLowerForSecondSet: null,
    lowerClearRetainerDesignLowerOptionForSecondSet: null,
    lowerPontics: null,
    lowerBiteRamp: null,
};

export const initRetainerReqFormValue = {
    retainer_request_id: null,
    impression_type: null,
    upper_fixed_wire: 0,
    upper_retainer_type_id: null,
    upper_bleaching_retainers_select: null,
    upper_wire_select: null,
    upper_jig_placement_select: null,
    upper_bite_ramp: [],
    upper_low_trimline_area_select_3: null,
    upper_low_trimline_area_select_1: null,
    lower_low_trimline_area_select_3: null,
    lower_low_trimline_area_select_1: null,
    upper_clear_retainer_design_upper_option: null,
    // "upper_clear_retainer_design_lower_option": null,
    upper_clear_retainer_design_upper_option_for_second_set: null,
    // "upper_clear_retainer_design_lower_option_for_second_set": null,
    upper_pontic: null,
    upper_pontic_color: null,
    lower_retainer_type_id: null,
    lower_fixed_wire: null,
    lower_bleaching_retainers_select: null,
    lower_wire_select: null,
    lower_jig_placement_select: null,
    lower_bite_ramp: [],
    // "lower_clear_retainer_design_upper_option": null,
    lower_clear_retainer_design_lower_option: null,
    // "lower_clear_retainer_design_upper_option_for_second_set": null,
    lower_clear_retainer_design_lower_option_for_second_set: null,
    lower_pontic: null,
    lower_pontic_color: null,
    use_latest_approved_treatment_plan: null,
    is_case_created_after_all_delivered: 0,
    special_instruction: null,
};

export const baseTeethValue = {
    toothBiteRamp: [],
    toothPontics: [],
    upperToothBiteRamp: [],
    upperToothPontics: [],
    lowerToothBiteRamp: [],
    lowerToothPontics: [],
};

const initialState = {
    supportedRetainerTypes: [],
    prescriptionFormValues: initFormvalue,
    questions: questions,

    toothBiteRamp: [],
    toothPontics: [],
    upperToothBiteRamp: [],
    upperToothPontics: [],
    lowerToothBiteRamp: [],
    lowerToothPontics: [],

    specialInstruction: '',
    retainerRequestId: null,

    enableOrderDifferentRetainer: false, // for enable order different retainer after all retaienrs delivered
    targetTypeRetainerValidationFunc: null,
};

export const diffRetainerReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SUPPROTED_RETAINTER_TYPES:
            const retainerTypes = Array.isArray(action.payload) && action.payload.length > 0 ? action.payload : [];
            return {
                ...state,
                supportedRetainerTypes: retainerTypes,
            };
        case SAVE_FORM_VALUES:
            // console.log("reached save form value")
            // console.log("payload => ", action.payload)
            let baseToothBiteRamp = [];
            let baseUpperToothBiteRamp = [];
            let baseLowerToothBiteRamp = [];
            if (action.payload.impressionType) {
                if (action.payload.impressionType === IMPRESSION_TYPE.UPPER) {
                    baseToothBiteRamp = action.payload.upperBiteRamp || [];
                }
                if (action.payload.impressionType === IMPRESSION_TYPE.LOWER) {
                    baseToothBiteRamp = action.payload.lowerBiteRamp || [];
                }
                if (action.payload.impressionType === IMPRESSION_TYPE.UPPER_AND_LOWER) {
                    baseUpperToothBiteRamp = action.payload.upperBiteRamp || [];
                    baseLowerToothBiteRamp = action.payload.lowerBiteRamp || [];
                }
            }
            return {
                ...state,
                prescriptionFormValues: { ...action.payload },
                toothBiteRamp: baseToothBiteRamp,
                upperToothBiteRamp: baseUpperToothBiteRamp,
                lowerToothBiteRamp: baseLowerToothBiteRamp,
            };
        case RESET_FORM_VALUES:
            return {
                ...state,
                prescriptionFormValues: initFormvalue,
            };
        case SET_TOOTH_SELECTIONS:
            return {
                ...state,
                toothBiteRamp: action.payload.toothBiteRamp,
                toothPontics: action.payload.toothPontics,
                upperToothBiteRamp: action.payload.upperToothBiteRamp,
                upperToothPontics: action.payload.upperToothPontics,
                lowerToothBiteRamp: action.payload.lowerToothBiteRamp,
                lowerToothPontics: action.payload.lowerToothPontics,
            };
        case RESET_TOOTH_SELECTIONS:
            return {
                ...state,
                toothBiteRamp: [],
                toothPontics: [],
                upperToothBiteRamp: [],
                upperToothPontics: [],
                lowerToothBiteRamp: [],
                lowerToothPontics: [],
            };
        case RESET_SINGLE_TOOTH_SELECTIONS:
            const isResetUpper = action.payload === 'Upper';

            if (isResetUpper) {
                return {
                    ...state,
                    upperToothBiteRamp: [],
                    upperToothPontics: [],
                };
            }
            return {
                ...state,
                lowerToothBiteRamp: [],
                lowerToothPontics: [],
            };
        case SET_QUESTIONS:
            let cloned = { ...state.questions };
            cloned[3].option = action.payload || state.questions[3].option;
            return {
                ...state,
                questions: cloned,
            };
        case SET_ENABLE_ORDER_DIFFERENT_RETAINER:
            return {
                ...state,
                enableOrderDifferentRetainer: action.payload,
            };
        case SET_TARGET_TYPE_FORM_VALIDATION_FUNC:
            return {
                ...state,
                targetTypeRetainerValidationFunc: action.payload,
            };
        case SAVE_IMPRESSION_TYPE_FORM_VALUES:
            // when impression type is changed then reset the form values
            return {
                ...state,
                prescriptionFormValues: {
                    ...initFormvalue,
                    impressionType: action.payload,
                },
            };
        case SET_SINGLE_TYPE_BITE_RAMP_TEETH_SELECTIONS:
            return {
                ...state,
                toothBiteRamp: action.payload,
            };
        case SET_BOTH_UPPER_TYPE_BITE_RAMP_TEETH_SELECTIONS:
            return {
                ...state,
                upperToothBiteRamp: action.payload,
            };
        case SET_BOTH_LOWER_TYPE_BITE_RAMP_TEETH_SELECTIONS:
            return {
                ...state,
                lowerToothBiteRamp: action.payload,
            };
        case SET_SPECIAL_INSTRUCTION:
            const specialInstruction = action.payload;
            return {
                ...state,
                specialInstruction,
            };
        case SET_RETAINER_REQ_ID:
            const retainerRequestId = action.payload;
            return {
                ...state,
                retainerRequestId,
            };
        default:
            return state;
    }
};
